/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './note-list-item.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../app/note-list-item/note-list-item.component';
import * as i5 from '../../../app/service/data.service';
const styles_NoteListItemComponent:any[] = [i0.styles];
export const RenderType_NoteListItemComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NoteListItemComponent,data:{}});
export function View_NoteListItemComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'list-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          9,'a',[['class','list-group-item']],[[1,'target',0],[8,'href',4]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,3).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(2),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'h4',[['class','list-group-item-heading']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class','list-group-item-text ellipsize']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i4.NoteListItemComponent = _v.component;
    const currVal_2:any = _ck(_v,4,0,'note',_co.note.$key);
    _ck(_v,3,0,currVal_2);
  },(_ck,_v) => {
    var _co:i4.NoteListItemComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,3).target;
    const currVal_1:any = i1.ɵnov(_v,3).href;
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_3:any = _co.note.title;
    _ck(_v,7,0,currVal_3);
    const currVal_4:any = _co.note.content;
    _ck(_v,10,0,currVal_4);
  });
}
export function View_NoteListItemComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-note-list-item',
      ([] as any[]),(null as any),(null as any),(null as any),View_NoteListItemComponent_0,
      RenderType_NoteListItemComponent)),i1.ɵdid(49152,(null as any),0,i4.NoteListItemComponent,
      [i5.DataService],(null as any),(null as any))],(null as any),(null as any));
}
export const NoteListItemComponentNgFactory:i1.ComponentFactory<i4.NoteListItemComponent> = i1.ɵccf('app-note-list-item',
    i4.NoteListItemComponent,View_NoteListItemComponent_Host_0,{note:'note'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2RhcnlsYmVyZ2Vyb24vRG9jdW1lbnRzL3dlYnN0dWZmL2FuZ3VsYXIvZmlyZW5vdGVzL3NyYy9hcHAvbm90ZS1saXN0LWl0ZW0vbm90ZS1saXN0LWl0ZW0uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2RhcnlsYmVyZ2Vyb24vRG9jdW1lbnRzL3dlYnN0dWZmL2FuZ3VsYXIvZmlyZW5vdGVzL3NyYy9hcHAvbm90ZS1saXN0LWl0ZW0vbm90ZS1saXN0LWl0ZW0uY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvZGFyeWxiZXJnZXJvbi9Eb2N1bWVudHMvd2Vic3R1ZmYvYW5ndWxhci9maXJlbm90ZXMvc3JjL2FwcC9ub3RlLWxpc3QtaXRlbS9ub3RlLWxpc3QtaXRlbS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL2RhcnlsYmVyZ2Vyb24vRG9jdW1lbnRzL3dlYnN0dWZmL2FuZ3VsYXIvZmlyZW5vdGVzL3NyYy9hcHAvbm90ZS1saXN0LWl0ZW0vbm90ZS1saXN0LWl0ZW0uY29tcG9uZW50LnRzLk5vdGVMaXN0SXRlbUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJsaXN0LWdyb3VwXCI+XG4gIDxhIGNsYXNzPVwibGlzdC1ncm91cC1pdGVtXCIgW3JvdXRlckxpbmtdPVwiWydub3RlJywgbm90ZS4ka2V5XVwiPlxuICAgIDxoNCBjbGFzcz1cImxpc3QtZ3JvdXAtaXRlbS1oZWFkaW5nXCI+e3sgbm90ZS50aXRsZSB9fTwvaDQ+XG4gICAgPHAgY2xhc3M9XCJsaXN0LWdyb3VwLWl0ZW0tdGV4dCBlbGxpcHNpemVcIj57eyBub3RlLmNvbnRlbnQgfX08L3A+XG4gIDwvYT5cbjwvZGl2PiIsIjxhcHAtbm90ZS1saXN0LWl0ZW0+PC9hcHAtbm90ZS1saXN0LWl0ZW0+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBd0IseUNBQ3RCO1VBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBMkIsSUFBbUMsMkNBQzVEO2lCQUFBO2NBQUE7TUFBb0Msd0NBQXFCO01BQ3pEO1VBQUE7TUFBMEMsd0NBQXNCO01BQzlEOztJQUh1QjtJQUEzQixXQUEyQixTQUEzQjs7O0lBQUE7SUFBQTtJQUFBLFdBQUEsbUJBQUE7SUFDc0M7SUFBQTtJQUNNO0lBQUE7Ozs7b0JDSDlDO01BQUE7c0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/note-list-item/note-list-item.component.ngfactory.ts